<nav
  class="navbar navbar-expand-lg navbar-light border-bottom bg-gradient topbar static-top shadow mb-1 sticky-navbar w-100 p-0 fixed-header position-relative">
  <div class="container-fluid d-flex justify-content-between w-100 ">
    <!-- Left Section: Sidebar Toggle, Logo -->
    <div class="d-flex align-items-center">
      <!-- Logo -->
      <a class="navbar-brand d-flex align-items-center d-none d-md-flex" href="/">
        <img :src="$clientLogo" class="img-fluid logo" alt="Logo" />
      </a>

<!-- Mobile Logo -->
      <a class="navbar-brand d-flex align-items-center d-flex d-md-none" href="/">
        <img :src="$clientLogo" class="img-fluid w-180" alt="Logo" />
      </a>
    </div>

    <!-- Center Section: Search Bar (Desktop) -->
    <div class="d-none d-lg-flex flex-grow-1 justify-content-center position-relative">
      <input v-if="token_exists" v-model="searchQuery" type="text"
        class="form-control text-xs w-25 rounded-pill p-2 shadow" placeholder="Search..." />
      <div v-if="filteredProfiles" class="mt-5 position-absolute">
       <!-- Add this to your search results list -->
      <ul class="list-group">
        <!-- People Header -->
        <li v-if="filteredProfiles.profiles?.length" class="list-group-item bg-light">
          <small class="text-muted fw-bold">People</small>
        </li>
        <!-- People -->
        <li v-for="profile in filteredProfiles.profiles" :key="`profile-${profile.id}`" class="list-group-item">
          <div class="d-flex align-items-center gap-3 mx-3">
            <div class="profile-avatar">
              <i class='bx bxs-user-circle text-secondary fs-2'></i>
            </div>
            <div class="d-flex flex-column">
              <a @click="getProfileLink(profile.user)" class="text-decoration-none text-dark">
                {{ profile.user.first_name }} {{ profile.user.last_name }}
              </a>
              <small class="text-muted">{{ profile?.user.email || '' }}</small>
            </div>
          </div>
        </li>

        <!-- Companies Header -->
        <li v-if="filteredProfiles.companies?.length" class="list-group-item bg-light">
          <small class="text-muted fw-bold">Companies</small>
        </li>
        <!-- Companies -->
        <li v-for="company in filteredProfiles.companies" :key="`company-${company.id}`" class="list-group-item">
          <div class="d-flex align-items-center gap-3 mx-3">
            <i class='bx bxs-briefcase text-secondary fs-2'></i>
            <div class="d-flex flex-column">
              <a @click="view_profile(company)" class="text-decoration-none text-dark">
                {{ company.company_name }}
              </a>
              <small class="text-muted">{{ company?.location || '' }}</small>
            </div>
          </div>
        </li>

        <!-- Portals Header -->
        <li v-if="filteredProfiles.portals?.length" class="list-group-item bg-light">
          <small class="text-muted fw-bold">Portals</small>
        </li>
        <!-- Portals -->
        <li v-for="portal in filteredProfiles.portals" :key="`portal-${portal.id}`" class="list-group-item">
          <div class="d-flex align-items-center gap-3 mx-3">
            <i class='bx bx-globe text-secondary fs-2'></i>
            <div class="d-flex flex-column">
              <a @click="view_portal(portal)" class="text-decoration-none text-dark">
                {{ portal.portal_name || portal.name }}
              </a>
              <small class="text-muted">{{ portal?.description || '' }}</small>
            </div>
          </div>
        </li>

        <!-- Loading State -->
        <li v-if="isLoading" class="list-group-item text-center">
          <div class="spinner-border spinner-border-sm" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </li>
        <li v-else-if="!filteredProfiles.profiles?.length && !filteredProfiles.companies?.length && !filteredProfiles.portals?.length && searchQuery"
          class="list-group-item">
          <div class="d-flex align-items-center gap-3 mx-3">
            <i class='bx bx-search-alt text-primary fs-2'></i>
            <div class="d-flex flex-column">
              <span class="text-muted">No results found</span>
            </div>
          </div>
        </li>
      </ul>
      </div>
    </div>

    <!-- Right Section: Icons, Notifications, and User Menu -->
    <div class="d-flex align-items-center">
      <a class="d-flex align-items-center justify-content-start text-decoration-none text-dark text-xs fw-500" v-if="token_exists && user_details.user_role == 'admin' "
          href="/dashboard">
          <img src="@/assets/images/dashboard.png" class="w-50" alt="">
          <span class="ms-2"></span>
        </a>
      <!-- Mobile Search Icon -->
      <div v-if="token_exists" class="d-flex d-lg-none align-items-center position-relative me-1">
        <img id="search-icon" src="@/assets/images/search.png" class="w-20" alt=""  @click="toggleSearch">
      </div>

      <NotificationDropdown class="d-none d-xl-block me-3" />

      <!-- User Menu -->
      <ul class="navbar-nav d-flex flex-row justify-content-end align-items-center text-xs fw-500 me-3"
        v-if="token_exists">

        <li class="nav-item no-arrow mx-1 mt-1">
          <!-- Profile Avatar Trigger with Notification Badge -->
          <a class="nav-link dropdown-toggle avatar-button d-flex align-items-center" href="#" id="messages_dropdown"
            role="button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <img v-if="user_details.profile_image" :src="user_details.profile_image"
              class="rounded-circle profile-image">
            <span v-else class="text-change">{{ base_profiles.find(profile => profile.is_active)?.profile_name.charAt(0) ||
              user_details.first_name.charAt(0) }}</span>
          </a>

          <!-- Extended Dropdown Menu -->
          <div class="dropdown-menu dropdown-menu-end shadow border-0 p-0 profile-dropdown-menu">

            <!-- User Profile Section -->
            <div class="p-3 border-bottom">
              <!-- -->

              <div class="mb-2">
                <!-- Personal Profiles -->
                <h6 class="dropdown-header text-muted">Main Profiles</h6>
                <div
                  v-for="base_profile in visibleProfiles.filter(profile => profile.profile_type ===typeOfProfileId('personal'))"
                  :key="base_profile.id">
                  <a href="#" @click.prevent="switchProfile(base_profile.id)"
                    class="d-flex align-items-center text-decoration-none text-dark p-2 rounded hover-bg-light">
                    <div class="me-2 profile-list-avatar">
                      <img v-if="base_profile.profile_image" :src="base_profile.profile_image"
                        class="rounded-circle profile-image">
                      <div v-else
                        class="rounded-circle bg-secondary text-white d-flex align-items-center justify-content-center profile-list-initial">
                        {{ base_profile.profile_name.charAt(0) || user_details.first_name.charAt(0) }}
                      </div>
                    </div>
                    <span class="text-xs">{{ base_profile.profile_name || user_details.first_name }}</span>
                    <i v-if="base_profile.is_active" class="bx bx-check text-primary ms-auto"></i>
                  </a>
                </div>

                <!-- Business Profiles -->
                <h6 v-if="visible_domain" class="dropdown-header text-muted mt-3">Business Profiles</h6>
                <div v-if="visible_domain"
                  v-for="base_profile in visibleProfiles.filter(profile => profile.profile_type === typeOfProfileId('business'))"
                  :key="base_profile.id">
                  <a href="#" @click.prevent="switchProfile(base_profile.id)"
                    class="d-flex align-items-center text-decoration-none text-dark p-2 rounded hover-bg-light">
                    <div class="me-2 profile-list-avatar">
                      <img v-if="base_profile.profile_image" :src="base_profile.profile_image"
                        class="rounded-circle profile-image">
                      <div v-else
                        class="rounded-circle bg-secondary text-white d-flex align-items-center justify-content-center profile-list-initial">
                        {{ base_profile.profile_name.charAt(0) || user_details.first_name.charAt(0) }}
                      </div>
                    </div>
                    <span class="text-xs">{{ base_profile.profile_name || user_details.first_name }}</span>
                    <i v-if="base_profile.is_active" class="bx bx-check text-primary ms-auto"></i>
                  </a>
                </div>
              </div>
            </div>
            <div class="">
              <a :href="user_details.user_role === 'user' ? '/customer_profile' : '/profile'"
                class="dropdown-item d-flex align-items-center justify-content-between p-2">
              </a>

              <button class="dropdown-item d-flex align-items-center" @click="logout_user()">
                <div class="me-3 d-flex align-items-center fw-bold justify-content-center menu-icon">
                  <i class="bx bx-log-out"></i>
                </div>
                <span class="fw-bold text-xs">Log Out</span>
              </button>
            </div>

          </div>
        </li>
      </ul>



      <!-- Auth Links (If No Token) -->
      <ul
        :class="['navbar-nav d-flex flex-row align-items-center text-xs fw-500 ms-auto', token_exists ? 'd-none' : '']">
        <li class="nav-item ms-2">
          <router-link v-if="!workbook_domain"
            class="nav-link btn btn-primary btn-sm text-white text-xxs shadow-sm rounded-3" to="sign_up_finale">
            Sign up
          </router-link>
        </li>
        <li class="nav-item mx-2">
          <a class="nav-link btn btn-primary btn-sm text-white text-xxs shadow-sm rounded-3" href="/sign_in_Finale">
            Login
          </a>
        </li>
      </ul>
    </div>
  </div>

  <!-- Second Row: Mobile Search Input -->
  <div v-if="showSearch" class="container-fluid mt-2">
    <input v-model="searchQuery" type="text" class="form-control p-1 mb-3 rounded-5 shadow " placeholder="Search..."
      @blur="toggleSearch" />
    <div v-if="filteredProfiles"
      class="position-absolute top-100 start-0 w-100 p-0 me-5 bg-white shadow rounded-bottom overflow-auto z-3 col-sm">
      <ul class="list-group">
        <!-- Section Headers -->
        <li v-if="filteredProfiles.profiles?.length" class="list-group-item bg-light">
          <small class="text-muted fw-bold">People</small>
        </li>

        <!-- Personal Profiles -->
        <li v-for="profile in filteredProfiles.profiles" :key="`profile-${profile.id}`" class="list-group-item">
          <div @click="getProfileLink(profile.user)"class="d-flex align-items-center gap-3 mx-3">
            <div class="profile-avatar">
              <i class='bx bxs-user-circle text-secondary fs-2'></i>
            </div>
            <div class="d-flex flex-column">
              <a class="text-decoration-none text-dark">
                {{ profile.user.first_name }} {{ profile.user.last_name }}
              </a>
              <small class="text-muted">{{ profile?.user.email || '' }}</small>
            </div>
          </div>
        </li>

        <!-- Companies Header -->
        <li v-if="filteredProfiles.companies?.length" class="list-group-item bg-light">
          <small class="text-muted fw-bold">Companies</small>
        </li>

        <!-- Companies -->
        <li v-for="company in filteredProfiles.companies" :key="`company-${company.id}`" class="list-group-item">
          <div class="d-flex align-items-center gap-3 mx-3">
            <i class='bx bxs-briefcase  text-secondary fs-2'></i>
            <div class="d-flex flex-column">
              <a @click="view_profile(company)" class="text-decoration-none text-dark">
                {{ company.company_name }}
              </a>
              <small class="text-muted">{{ company?.location || '' }}</small>
            </div>
          </div>
        </li>

        <!-- Loading State -->
        <li v-if="isLoading" class="list-group-item text-center">
          <div class="spinner-border spinner-border-sm" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </li>

      </ul>
    </div>
  </div>
</nav>

<teleport to="body">
  <div class="modal fade" id="company_profile_modal" tabindex="-1" aria-labelledby="company_profile_modallabel"
    aria-hidden="true">
    <div class="modal-dialog modal-lg  modal-dialog-centered">
      <div class="modal-content border-0">
        <div class="modal-header">
          <h5 class="modal-title" id="company_profile_modallabel">
          {{ is_edit_mode ? 'Edit Business Profile' : 'Create Company Profile' }}
        </h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <form @submit.prevent="is_edit_mode ? update_company_profile() : saveCompanyProfile()" id="companyProfileForm" novalidate class="text-xs">
            <div class="mb-3">
              <label for="company_name" class="form-label fw-500">Company Name<span class="text-danger">
                  *</span></label>
              <input type="text" class="form-control text-xs rounded-5" id="company_name" v-model="company_name"
                placeholder="Company name" :class="{ 'is-invalid': errors.company_name }">
              <p v-if="errors.company_name" class="text-danger text-xs">{{ errors.company_name }}</p>
            </div>

            <div class="mb-3">
              <label for="type_of_organization" class="form-label fw-500">Type of Organization<span class="text-danger">
                  *</span></label>
              <select class="form-control text-xs rounded-5" id="type_of_organization"
                v-model="selected_type_of_organization" :class="{ 'is-invalid': errors.type_of_organization_id }">
                <option value="">Select Organization Type</option>
                <option v-for="type in type_of_organization" :key="type.id" :value="type.id">
                  {{ type.type_of_organization.replace('_', ' ').toUpperCase() }}
                </option>
              </select>
            </div>

            <QuillEditor theme="snow" v-model="description" ref="quillCompanyEditorRef" class="quill-editor"
              placeholder="Enter your description here..." toolbar="full" />

            <div class="mb-3">
              <label for="email" class="form-label fw-500">Company Email<span class="text-danger"> *</span></label>
              <input type="email" class="form-control text-xs rounded-5" id="email" v-model="email"
                placeholder="Company email" :class="{ 'is-invalid': errors.email }">
            </div>

            <div class="mb-3">
              <label for="tell_number" class="form-label fw-500">Company Telephone<span class="text-danger">
                  *</span></label>
              <input type="text" class="form-control text-xs rounded-5" id="tell_number" v-model="tell_number"
                placeholder="Telephone number" :class="{ 'is-invalid': errors.tell_number }">
            </div>

            <div class="mb-4">
              <label for="mapSearchBox" class="form-label text-xs fw-500 d-block">Search for Location</label>
              <input id="mapSearchBox" type="text" class="form-control rounded-5 text-xs"
                placeholder="Search location..." v-model="location" />
            </div>
            <div class="text-end">
              <button type="submit" class="btn btn-primary btn-sm text-white text-xs shadow-sm rounded-3">
              {{ is_edit_mode ? 'Update' : 'Save' }}
            </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</teleport>